export default __webpack_public_path__ + "static/media/border-inner.afbacf76.svg";